
/**
 * @export
 * @enum {string}
 */
export enum SearchListType {
    COMPANY = 'COMPANY',
    INVESTOR = 'INVESTOR',
    SP = 'SP',
    LP = 'LP',
    PERSON = 'PERSON',
    DEBT = 'DEBT'
}